/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticleTeaserBodytext from 'base/components/labrador/ArticleTeaser/Bodytext';

export const DynamicLabradorArticleTeaserBodytext: typeof LabradorArticleTeaserBodytext = (props) => {
    return <ErrorBoundary><LabradorArticleTeaserBodytext {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleTeaserBodytextProps = PropsFromComponent<typeof LabradorArticleTeaserBodytext>;
